module.exports = __webpack_public_path__ + "assets/4-denver-sales-recruiting-process.3c942ff9.png";